import { Injectable } from '@angular/core';
import { LoginRequestDto } from '../models/login-request.dto';
import { Observable } from 'rxjs';
import { LoginResponseDto } from '../models/login-response.dto';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ACCESS_TOKEN } from '../constants/keys.const';
import { BaseResponse } from '../models/base-response.model';
import { Profile } from 'src/app/proxy/account';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private httpClient: HttpClient) {}

  public profile: Profile = null;

  public login(input: LoginRequestDto): Observable<LoginResponseDto> {
    var body = {
      phone: input.phone,
      password: input.password,
    };

    const data = Object.keys(body)
      .map((key, index) => `${key}=${encodeURIComponent(body[key])}`)
      .join('&');
    return this.httpClient.post<LoginResponseDto>(
      environment.apis.default.url + '/admin/login',
      data,
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
    );
  }

  public refreshToken(refreshToken: string): Observable<LoginResponseDto> {
    var body = {
    };

    const data = Object.keys(body).map((key, index) => `${key}=${encodeURIComponent(body[key])}`).join('&');
    return this.httpClient.post<LoginResponseDto>(
      environment.apis.default.url + 'connect/token',
      data,
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
    );
  }

  public isAuthenticated(): boolean {
    return window.localStorage.getItem(ACCESS_TOKEN) != null;
  }

  public getProfile(): Profile {
    return this.profile;
  }

  public setProfile(profile: Profile) {
    this.profile = profile;
  }

  public logout() {
    window.localStorage.removeItem(ACCESS_TOKEN);  
  }

  public logoutServer() {
    return this.httpClient.post<BaseResponse<boolean>>(
      environment.apis.default.url + '/admin/logout',
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
    );
  }
}
